
import {Vue, Component, Prop} from 'vue-property-decorator';
@Component({
  name: 'nameOneRowLen',
  components: {},
})
export default class nameOneRowLen extends Vue {
  private orgDataArr = JSON.parse(JSON.stringify(require('./legalBasis.json')));
  private dataArr = [] as any;
  private dialogData = {
    dialog: false,
    activeIndex: 0,
  }

  showDialog() {
    this.dataArr = JSON.parse(JSON.stringify(this.orgDataArr));
    this.dialogData.activeIndex = 0;
    this.dialogData.dialog = true;
  }

  saveBtn() {
    console.log(this.dataArr)
    let dataStr = '';
    for(const d of this.dataArr) {
      for(const s of d.selected) {
        dataStr += ('《'+d.title+'》' + s.zhang + ' ' + s.tiao + '\n' + s.content + '\n');
      }
    }
    this.$emit("outputData", dataStr);
    this.dialogData.dialog = false;
  }

  memberSelect(val: any) {
    this.dataArr[this.dialogData.activeIndex]['selected'] = val;
  }

  closeDialog() {
    this.dataArr = [];
  }
}
